import { RefreshButton, Show, Typography, Divider, Space, EditButton, Alert, Tag } from "@pankod/refine-antd";
import { CanAccess, IResourceComponentsProps, useOne, useShow } from "@pankod/refine-core";
import { IArticle, IArticleMetadata } from "interfaces/article";
import { DATAPROVIDER_LOOKUP, DATAPROVIDER_READ, DATAPROVIDER_UPDATE, HELIUM_LOGO_PATH, RESOURCE_PATH } from "scripts/site";
import MDEditor from "@uiw/react-md-editor";
import { getAppTheme } from "scripts/theme";
import { IBaseProps, arrayExtensions } from "@architecture-innovation-transformation/lib-common";
import { ShowUserCard } from "components/profile/showUserCard";
import { StateButtons } from "components/common";
import dayjs from "dayjs";
import { RenderSocialButtons } from "components/common/socialButtons";

export const ArticleShow: React.FC<IResourceComponentsProps> = () => {

  const { queryResult } = useShow<IArticle>({
    dataProviderName: DATAPROVIDER_READ
  });

  const { data: metadata } = useOne<IArticleMetadata>({
    dataProviderName: DATAPROVIDER_LOOKUP,
    resource: RESOURCE_PATH.METADATA,
    id: RESOURCE_PATH.ARTICLE
  });
  const metaConfig = metadata?.data?.config;

  const { data, isLoading } = queryResult;
  const { Title, Text } = Typography;
  const record = data?.data as IArticle;

  return (
    <Show
      isLoading={isLoading}
      headerProps={{
        title: "",
        backIcon: true,
        extra: <>
          <RefreshButton></RefreshButton>
          {record &&
            <CanAccess key={RESOURCE_PATH.ARTICLE} resource={RESOURCE_PATH.ARTICLE.toLowerCase()} action="edit" params={{ dataProviderName: DATAPROVIDER_UPDATE, id: record.id }}>
              <EditButton style={{ marginRight: 8 }} ></EditButton>
              <StateButtons {...record as IBaseProps}
                resourceToAct={RESOURCE_PATH.ARTICLE}
                resourceToActId={record?.id || "0"}
                resourceToNavigate={RESOURCE_PATH.ARTICLE}
              />
            </CanAccess>
          }
        </>
      }}
    >
      <Title level={3}>{record?.name}</Title>
      {record?.authorName &&
        <>
          <Text style={{ color: "GrayText" }}>By: </Text>
          <Space wrap split={<Divider type="vertical" />} >
            {arrayExtensions.validateArray(record?.authorName ?? []) ? record?.authorName?.map((e, i) => <ShowUserCard key={`author-${i}`} id={e}></ShowUserCard>) : "None"}
          </Space>
        </>
      }
      {record?.publishedDate &&
        <div>
          <Text style={{ color: "GrayText" }}>Published on: </Text>
          <Text style={{ color: "GrayText" }}>{dayjs(record.publishedDate).format('LLLL')}</Text>
        </div>
      }

      {metaConfig?.socialElement?.displayStates?.includes(record?.stateManager?.state) &&
        <RenderSocialButtons socialElementId={record.socialElementId} activeMode={metaConfig?.socialElement?.activeStates?.includes(record?.stateManager?.state)} />
      }

      <Alert
        message="Synopsis"
        description={record?.description}
        type="info"
        showIcon
        style={{ marginTop: "1.2em" }}
      />
      <Divider></Divider>
      {arrayExtensions.validateArray(record?.body ?? []) &&
        record?.body?.map((content, i) =>
          <div className="artcle" key={`art-${i}`}>
            {content.isImageAdded && content.alignment === "ImageAboveParagraph" &&
              <div className="img-cntnr">
                <img
                  key={`artimg-${i}`}
                  alt={record?.name}
                  src={record?.articleImages?.find(img => img.uid === content.paraImage)?.url || HELIUM_LOGO_PATH}
                />
                {content.imageTitle && <Typography.Text style={{ color: "GrayText" }}>{content.imageTitle}</Typography.Text>}
              </div>
            }
            <div className="container" key={`para-${i}`} data-color-mode={getAppTheme()}>
              <MDEditor.Markdown source={content.paragraph} />
            </div>
            {content.isImageAdded && content.alignment === "ImageBelowParagraph" &&
              <div className="img-cntnr">
                <img
                  key={`artimg-${i}`}
                  alt={record?.name}
                  src={record?.articleImages?.find(img => img.uid === content.paraImage)?.url || HELIUM_LOGO_PATH}
                />
                {content.imageTitle && <Typography.Text style={{ color: "GrayText" }}>{content.imageTitle}</Typography.Text>}
              </div>
            }
          </div>
        )
      }
      <Divider></Divider>
      {arrayExtensions.validateArray(record?.tagList) &&
        <>
          <Space wrap>
            <Typography.Title level={5}>Tags:</Typography.Title>
            <Tag style={{ margin: "5px" }} color={"green"}>{record?.contentType}</Tag>
            {arrayExtensions.validateArray(record?.tagList ?? []) ? record?.tagList?.map((e, i) => <Tag key={`tag-${i}`}>{e}</Tag>) : ""}
          </Space>
        </>
      }
    </Show>
  );
};